module.exports = __webpack_public_path__ + "img/total_persentase_sp2d.ef189b08.png";